<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>代理商管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>代理商列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>代理商列表</span>
        </div>
        <span class="xcx-add left font14" @click="add()">添加代理商</span>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column align="center" prop="id" label="UID" width="60"></el-table-column>
          <el-table-column align="center" prop="username" label="账号" width="160"></el-table-column>
          <el-table-column align="center" prop="contact" label="联系人" width="160"></el-table-column>
          <el-table-column align="center" prop="mobile" label="联系方式" width="220"></el-table-column>
          <el-table-column align="center" label="绑定域名" width="*">
            <template slot-scope="scope">
              <el-link
                :href="'http://' + scope.row.uhost + '.' + scope.row.udomain"
                target="_blank"
              >
                http://{{
                scope.row.uhost
                }}.{{ scope.row.udomain}}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" label="到期时间" width="120">
            <template slot-scope="scope">
              <el-tag type="danger" v-if="scope.row.etime == -1">已到期</el-tag>
              <el-tag type="success" v-else-if="scope.row.etime == 0">永久有效</el-tag>
              <el-tag v-else>{{ scope.row.etime }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" width="80">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="setStatus(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="created_at" width="160" label="添加时间"></el-table-column>
          <el-table-column align="center" label="操作" width="300">
            <template #default="scope">
              <div class="doSonimg_box font14">
                <el-button size="mini" @click="edit(scope.row.id)">修改</el-button>
                <el-button size="mini" type="success" @click="setting(scope.row.id)">配置</el-button>
                <el-button size="mini" type="danger" @click="del_item(scope.row.id)">删除</el-button>
                <el-button
                  :loading="scope.row.loading == 1"
                  size="mini"
                  @click="toAppLink(scope.row)"
                  type="primary"
                >{{scope.row.loading == false ? '管理' : '登录中'}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination
            class="left"
            @current-change="handleCurrentChange"
            :current-page="page"
            background
            layout="prev, pager, next"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      mLoading: false,
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    add() {
      this.$router.push("/manage/add_user");
    },
    edit(ids) {
      this.$router.push({
        path: "/manage/add_user",
        query: {
          id: ids,
        },
      });
    },
    setting(ids) {
      this.$router.push({
        path: "/manage/setting",
        query: {
          id: ids,
        },
      });
    },

    toAppLink(item) {
      let that = this;
      item.loading = 1;
      that.axios
        .post("/toApp", { app_id: item.id })
        .then((res) => {
          setTimeout(function () {
            item.loading = 0;
            window.open(res.data);
          }, 1000);
        })
        .catch(() => {
          that.loading = false;
        });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/manage/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      that.axios.post("/manage/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
  },
};
</script>
<style>
</style>